import Vue from 'vue'
import App from './App.vue'
import store from './store'
import firebase from 'firebase/app';
import 'firebase/database';

Vue.config.productionTip = false

firebase.initializeApp ({
  apiKey: "AIzaSyAvma3BrdKrgY464xb4FVqydiFt447_htU",
  authDomain: "photo-gallery-asper.firebaseapp.com",
  databaseURL: "https://photo-gallery-asper.firebaseio.com",
  projectId: "photo-gallery-asper",
  storageBucket: "photo-gallery-asper.appspot.com",
  messagingSenderId: "953372831523",
  appId: "1:953372831523:web:d8464647a0661492566696"
});

export const db = firebase.database()
export const namesRef = db.ref('photoGallery/')

new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
